module.exports = __webpack_public_path__ + "static/media/1011583.9b2f92b4.png";